import { useState, useEffect } from 'react';
import { functionOp } from 'store/ducks/DataEntry/Functions';
import { ict_serviceOp } from 'store/ducks/DataEntry/ICTServices';

export interface ICTSystem {
  ict_system_category_id: any;
  ict_system_type_id: any;
  access_restricted: boolean;
  label: string;
  value: any;
  description: string;
  start_date: string;
  end_date: string;
  ict_system_site: string;
  ict_system_criticality_id: string | number;
  entity_id?: number | null;
  ict_system_category_name?: string | null;
  ict_system_criticality?: any;
  ict_system_type_name?: string | null;
}

const useICTSystems = (entityId: string, entityName: string) => {
  const [ictSystems, setIctSystems] = useState<ICTSystem[]>([]);

  const fetchICTSystems = async () => {
    try {
      const [functionsRes, servicesRes] = await Promise.allSettled([
        functionOp.fetchICTSystemsCategoryFunctionbyEntityName({
          entity_id: entityId,
          entity_name: entityName,
        }),
        ict_serviceOp.fetchICTSystemsCategoryICTServicesbyEntityName({
          entity_id: entityId,
          entity_name: entityName,
        }),
      ]);
      const formatData = (data: any[]) =>
        data?.map((system) => ({
          label: system.name,
          value: system.id,
          description: system.description,
          end_date: system.end_date,
          start_date: system.start_date,
          ict_system_category_id: system.ict_system_category_id ?? null,
          ict_system_type_id: system.ict_system_type_id ?? null,
          access_restricted: system.access_restricted,
          ict_system_site: system.ict_system_site,
          ict_system_criticality_id: system.ict_system_criticality_id,
          active: system.active ?? null,
          entity_id: system.entity_id ?? null,
          ict_system_category_name: system.ict_system_category_name ?? null,
          ict_system_criticality: system.ict_system_criticality ?? null,
          ict_system_type_name: system.ict_system_type_name ?? null,
        })) || [];

      const combinedData = [
        ...(functionsRes.status === 'fulfilled'
          ? formatData(functionsRes.value?.data || [])
          : []),
        ...(servicesRes.status === 'fulfilled'
          ? formatData(servicesRes.value?.data || [])
          : []),
      ];

      setIctSystems(combinedData);
    } catch (error) {
      setIctSystems([]);
    }
  };

  useEffect(() => {
    if (entityId && entityName) {
      fetchICTSystems();
    }
  }, [entityId, entityName]);

  return { ictSystems, refetch: fetchICTSystems };
};

export default useICTSystems;
